import { Link } from 'react-router-dom';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const HeroSection = () => {
  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center hero-pattern overflow-hidden pt-20 bg-white"
    >
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#1a365d]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#1a365d]/5 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Column - Text */}
          <div className="text-center lg:text-left">
            <h1 
              data-testid="hero-title"
              className="font-['Manrope'] text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1A1A1A] leading-tight mb-6"
            >
              Des Sites Web et Outils Digitaux professionnels pour{' '}
              <span className="text-[#1a365d]">faire grandir</span>{' '}
              votre entreprise
            </h1>
            
            <p 
              data-testid="hero-subtitle"
              className="text-base lg:text-lg text-[#4A4A4A] leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0"
            >
              Nous concevons des sites et outils modernes, rapides et optimisés 
              pour transformer vos visiteurs en clients.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Link to="/tarifs#quote-form">
                <Button 
                  data-testid="hero-cta-primary"
                  className="bg-[#1a365d] hover:bg-[#0f2440] text-white rounded-full px-8 py-6 text-sm font-semibold transition-all hover:scale-105 shadow-lg shadow-slate-700/20 w-full sm:w-auto"
                >
                  Demander un devis
                  <ArrowRight className="ml-2" size={18} />
                </Button>
              </Link>
            </div>

            {/* Trust badges */}
            <div className="mt-12 flex flex-wrap items-center gap-8 justify-center lg:justify-start">
              <div className="text-center">
                <p className="font-['Manrope'] text-2xl font-bold text-[#1A1A1A]">24h</p>
                <p className="text-xs text-[#4A4A4A] uppercase tracking-wide">Réponse rapide</p>
              </div>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="relative" data-testid="hero-image-container">
            <div className="relative bg-[#F0F0F0] rounded-2xl p-4 shadow-2xl hover-lift">
              <img
                src="https://images.unsplash.com/photo-1706700392626-5279fb90ae73?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
                alt="Site web moderne sur ordinateur portable"
                className="rounded-xl w-full h-auto"
                data-testid="hero-image"
              />
              {/* Floating badge */}
              <div className="absolute -bottom-4 -left-4 bg-white rounded-xl p-4 shadow-lg">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-[#10B981]/10 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-[#10B981]" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-[#111111]">Optimisé SEO</p>
                    <p className="text-xs text-[#666666]">Performance maximale</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div 
          className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce cursor-pointer"
          onClick={scrollToServices}
        >
          <ChevronDown size={28} className="text-[#4A4A4A]" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
